import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import Card from "../../../components/Card";
import { toast } from 'react-toastify';
import { API_USERS_LIST, API_USERS_SIGNUP } from "../../../service/url";
import { postApiCall, getApiCall } from "../../../service/httpCall";
import { useNavigate } from "react-router-dom";
import { getUserCreateAccessRoleLabel, ifUserAssociateCompany, getUser } from "../../../utilities/setting";
import { ROUTES, USERS_ROLE } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { API_ACL_SETTING_LIST, API_COMPANY_LIST, API_CALL_CENTRE_LIST, API_TTS_PLANS_LIST } from "../../../service/url";
import { USER_ROLES } from '../../../utilities/constant';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { validateEmail } from '../../../utilities/helpers'
import "../../../assets/custom/css/custom.css";
import Select from 'react-select';


const UserAdd = () => {
  const navigate = useNavigate();
  const [isOwnCompany, setIsOwnCompany] = useState(false);
  const { checkAuth } = useAuth();
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [aclSettingList, setAClSettingList] = useState([]);
  const [selectedACL, setSelectedACL] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isReseller, setIsReseller] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [loading, setLoading] = useState(true);
  const [isCompanyAdmin, setCompanyAdmin] = useState(false);
  const [isCallCenterAdmin, setCallCenterAdmin] = useState(false);
  const [channel, setChannel] = useState(0);
  const [callCenterAdminAgent, setCallCenterAdminAgent] = useState(0);
  const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
  const [agent, setAgent] = useState(0);
  const [liveAgent, setLiveAgent] = useState(0);
  const [selectedFlowType, setSelectedFlowType] = useState("");
  const [companyUserRole, setCompanyUserRole] = useState(false);
  const [availableLicence, setAvailableLicence] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [superAdminData, setSuperAdminData] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);

  const [errors, setErrors] = useState({
    role_ccagent: "",
    role_ccteamlead: "",
    agent: "",
    channel: "",
    live_agent: ""
  });

  const [emailError, setEmailError] = useState("");
  const [companyList, setCompanyList] = useState([])
  const [selectedCompany, setSelectedCompany] = useState("")
  const [callCenterList, setCallCenterList] = useState([])
  const [selectedCallCenter, setSelectedCallCenter] = useState("")
  const [loggedUserParent, setLoggedUserParent] = useState("")
  const [loggedUserSuperParent, setLoggedUserSuperParent] = useState("")
  const [loggedUserSuperSuperParent, setLoggedUserSuperSuperParent] = useState("")
  const [existingUsernames, setExistingUsernames] = useState([]);
  const [usernameTakenMessage, setUsernameTakenMessage] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [nameError, setNameError] = useState("");
  const [tts_plan_id, setTtsPlanId] = useState(null);
  const [showTtsPlanId, setShowTtsPlanId] = useState(false);
  const [ttsPlanList, setTtsPlanList] = useState([]);
  const [emailFieldError, setEmailFieldError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [aclError, setAclError] = useState("");
  const [userTypeError, setUserTypeError] = useState("");
  const [expiryDateError, setExpiryDateError] = useState("");

  useEffect(() => {
    if (!loading) {
      getApiCall(`${API_USERS_LIST}?role=noRole`, {})
        .then((data) => {
          const usernames = data.map((user) => user.username);
          setExistingUsernames(usernames);
        })
        .catch((error) => console.log("ERROR", error));
    }
  }, [loading]);

  useEffect(() => {
    if (selectedACL) {
      const selectedAclDetails = aclSettingList?.filter((item) => {
        return item?.id == selectedACL
      });
      if (selectedAclDetails && selectedAclDetails?.length > 0) {
        const modules = getKeysWithTrueValues(JSON.parse(selectedAclDetails?.[0]?.module_operations||'{}'));
        if (modules?.includes("TTS")) {
          setShowTtsPlanId(true);
        } else {
          setShowTtsPlanId(false);
        }
      }
    } else {
      setShowTtsPlanId(false);
    }
  }, [selectedACL]);

  function getKeysWithTrueValues(moduleOperations) {
    return Object.keys(moduleOperations).filter(key => {
        const permissions = moduleOperations[key];
        return Object.values(permissions).some(value => value === true);
    });
  }

  useEffect(() => {
    async function superadminCheck() {
      const user = JSON.parse(await AsyncStorage.getItem('user'));
      // const availableLicence = user?.sub_user_licence?.available_licence
      // setAvailableLicence(availableLicence)
      if (user.role === USER_ROLES.SUPERADMIN) {
        setIsSuperAdmin(true);
        setSuperAdminData(user);
      }

      if (user) {
          if (user && user.assignedCompany && user.assignedCompany?.is_own_company) {
            setIsOwnCompany(true);
          }
      }

      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        // setCompanyList([{
        //   id: user?.company?.id,
        //   name: user?.company?.name
        // }])
        // setSelectedCompany(user?.company?.id)
        setCompanyAdmin(true);
      }
      if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
        setCallCenterList([{
          id: user?.callcenter?.id,
          name: user?.callcenter?.name
        }])

        setSelectedCallCenter(user?.callcenter?.id)
        setCallCenterAdmin(true);
      }
      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        setCompanyUserRole(true);
      }
      if (user.role === USER_ROLES.RESELLER) {
        setIsReseller(true);
        setLoggedUserParent(user.role)
        setLoggedUserSuperParent(user?.createdByUser?.role)
        setLoggedUserSuperSuperParent(user?.createdByUser?.createdByUser?.role)
      }
      setLoading(false);
    }
    superadminCheck();
  }, []);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    if (!loading) {
      getApiCall(API_ACL_SETTING_LIST, {})
        .then(onAClSettingListSuccess)
        .catch(onError);
    }
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      getApiCall(API_COMPANY_LIST, {})
        .then(onCompanyListSuccess)
        .catch(onError);
    }
  }, [loading, superAdminData, isSuperAdmin]);

  function onCompanyListSuccess(resp) {
    if (!isCompanyAdmin) {
      setCompanyList(resp)
    }
    if (isSuperAdmin && superAdminData) {
      const filteredCompanies = resp.filter((item) => {
        return item.created_by == superAdminData?.id
      });
      setCompanyList(filteredCompanies);
    }
  }

  useEffect(() => {
    if (!loading) {
      getApiCall(API_CALL_CENTRE_LIST, {})
        .then(onCallcenterListSuccess)
        .catch(onError);
    }
  }, [loading]);

  function onCallcenterListSuccess(resp) {
    if (!isCallCenterAdmin) {
      setCallCenterList(resp)
    }
  }

  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);


  function onAClSettingListSuccess(resp) {
      setAClSettingList(resp);
  }

  useEffect(() => {
    getApiCall(API_TTS_PLANS_LIST).then((resp) => { 
      if (isSuperAdmin && superAdminData) {
        const filteredPlans = resp?.filter((item) => {
          return item.user_id == superAdminData?.id
        });
        setTtsPlanList(filteredPlans);
      } else {
        setTtsPlanList(resp) 
      }
    }).catch((error) => { toast.error(JSON.stringify(error)) })
  }, [superAdminData, isSuperAdmin]);


  function validateForm() {
    let valid = true;
    setEmailFieldError("");
    setPasswordError("");
    setConfirmPasswordError("");
    setAclError("");
    setUserTypeError("");
    setExpiryDateError("");
    if (!validateUsername(username)) {
      valid = false;
      if (!username.trim()) {
        toast.error("Username required");
      } else {
        toast.error(usernameError || "Invalid username format");
      }
    }
    if (!validateName(name)) {
      valid = false;
      if (!name.trim()) {
        toast.error("Name required");
      } else {
        toast.error(nameError || "Invalid name format");
      }
    }
    if (!email.trim()) {
      valid = false;
      setEmailFieldError("Email is required");
      toast.error("Email required");
    } 
    if (!password.trim()) {
      valid = false;
      setPasswordError("Password is required");
      toast.error("Password required");
    } else if (password.trim().length < 6) {
      valid = false;
      setPasswordError("Password must be at least 6 characters");
      toast.error("Password must be of minimum 6 characters");
    } 
    if (!confirmPassword.trim()) {
      valid = false;
      setConfirmPasswordError("Confirm Password is required");
      toast.error("Confirm password required");
    } else if (password.trim() != confirmPassword.trim()) {
      valid = false;
      setConfirmPasswordError("Passwords do not match");
      toast.error("Password and confirm password not matching");

    } 
    if (selectedUserType === USER_ROLES.RESELLER || selectedUserType === USER_ROLES.COMPANY_ADMIN) {
      if (selectedCompany === "" || selectedCompany === null || !selectedCompany) {
        valid = false;
        toast.error("Company is required");
      }
    } 
    if (selectedUserType == "role_ccadmin") {
      if (selectedFlowType === "" || selectedFlowType === null) {
        valid = false;
        toast.error("Flow type required");
      }
    }

    if ((isSuperAdmin || isCompanyAdmin || isCallCenterAdmin) && !selectedUserType) {
      valid = false;
      setUserTypeError("User Type is required");
    }

    if (!selectedACL && selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT) {
      valid = false;
      setAclError("ACL Settings is required");
      toast.error("ACL Settings is required");
    }

    if (emailError) {
      valid = false;
      toast.error("Enter correct Email");
    }

    if (isSuperAdmin || isCompanyAdmin || isCallCenterAdmin) {
      if (!selectedUserType.trim()) {
        valid = false;
        toast.error("UserType required");
      }
    }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
      if (!selectedCallCenter.trim()) {
        valid = false;
        toast.error("Callcenter required");
      }
    }

    if (!expiryDate) {
      valid = false;
      setExpiryDateError("Expiry date is required");
      toast.error("Expiry Date required");
    } else {
      // Validate expiry date format and range
      const selectedDate = new Date(expiryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // Check if date is valid
      if (isNaN(selectedDate.getTime())) {
        valid = false;
        toast.error("Invalid expiry date format. Please select a valid date.");
      } else {
        // Check if date is in the past
        if (selectedDate < today) {
          valid = false;
          toast.error("Expiry Date cannot be in the past. Please select a future date.");
        } else {
          // Check if date is too far in the future (max 100 years from today)
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 100);
          maxDate.setHours(0, 0, 0, 0);
          
          if (selectedDate > maxDate) {
            valid = false;
            toast.error("Expiry Date cannot be more than 100 years in the future. Please select a reasonable date.");
          }
        }
      }
    }

    if (showTtsPlanId) {
      if (!tts_plan_id) {
        valid = false;
        toast.error("TTS Plan is required when selecting ACL having TTS");
      }
    }

    return valid;
  }


  const updateLocalStorage = async (finalData) => {
    try {
      await AsyncStorage.setItem('user', JSON.stringify(finalData));
    } catch (error) {
      console.error('Error updating available licences:', error);
    }
  };


  async function submitForm() {
    setIsLoading(true);
    setButtonDisable(true);

    if (!validateForm()) {
      setIsLoading(false);
      setButtonDisable(false);
      return;
    }

    if (Object.values(errors).some(value => value !== "")) {
      toast.error("Enter All correct values");
      setIsLoading(false);
      setButtonDisable(false);
      return;
    }

    const sub_licence = {
      role_ccagent: Number(callCenterAdminAgent),
      role_ccteamlead: Number(callCenterAdminTeamlead),
      agent: Number(agent),
      channel: Number(channel),
      live_agent: Number(liveAgent)
    };

    const params = {
      username,
      password,
      name,
      email,
      acl_settings: (selectedACL === "") ? null : selectedACL,
      ...(selectedUserType == "role_ccadmin" && { flow_type: Number(selectedFlowType) })
    };

    if (selectedUserType === USER_ROLES.RESELLER || selectedUserType === USER_ROLES.COMPANY_ADMIN) {
      params.company = selectedCompany !== "" ? selectedCompany : null;
    }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
      params.callcenterId = selectedCallCenter
    }
    params.role = selectedUserType

    let finalData
    // if (!isReseller && !isSuperAdmin) {
    //   const { user, newAvailableLicences } = await updateAvailableLicences(sub_licence);
    //   finalData = user;
    //   params.parent_licence = newAvailableLicences;
    // }

    params.expiry_date = expiryDate;

    if (showTtsPlanId) {
      params.tts_plan_id = tts_plan_id;
    }

    try {
      const resp = await postApiCall(API_USERS_SIGNUP, params);

      if (resp) {
        await onUserCreateSuccess(resp);
      } else {
        throw new Error(resp?.message || "User creation failed");
      }
    } catch (error) {
      onUserCreateError(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  async function onUserCreateSuccess(resp) {
    // if (!isReseller && !isSuperAdmin) {
    //   await updateLocalStorage(finalData);
    //   setAvailableLicence(finalData?.sub_user_licence?.available_licence)
    // }

    toast.success("User created successfully");

    setTimeout(() => {
      navigate(`/${ROUTES.USERS.LIST}`);
    }, 1500);
  }

  function onUserCreateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      setButtonDisable(false);
      setIsLoading(false);
      toast.error(JSON.stringify(err));
    }
  }


  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      console.log(err)
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(validateEmail(value));
  };

  const validateUsername = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setUsernameError("Username is required");
      return false;
    }
    if (trimmedValue.length < 3 || trimmedValue.length > 50) {
      setUsernameError("Username must be between 3 and 50 characters");
      return false;
    }
    if (!/^[a-zA-Z0-9_]+$/.test(trimmedValue)) {
      setUsernameError("Username can only contain letters, numbers, and underscores");
      return false;
    }
    setUsernameError("");
    return true;
  };

  const validateName = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setNameError("Name is required");
      return false;
    }
    if (trimmedValue.length < 2 || trimmedValue.length > 100) {
      setNameError("Name must be between 2 and 100 characters");
      return false;
    }
    if (!/^[a-zA-Z0-9_]+$/.test(trimmedValue)) {
      setNameError("Name can only contain letters, numbers, and underscores");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    validateUsername(value);

    const trimmedValue = value.trim().toLowerCase();

    if (trimmedValue.length >= 1) {
      const isTaken = existingUsernames.some(
        (existing) => existing.toLowerCase() === trimmedValue
      );

      if (isTaken) {
        setButtonDisable(true)
        setUsernameTakenMessage(`Username "${trimmedValue}" already exists`);
      } else {
        setButtonDisable(false);
        setUsernameTakenMessage("");
      }
    } else {
      setUsernameTakenMessage("");
      setButtonDisable(true);
    }
  };

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">New User Information</h4>
                  {/* <RenderUserAccessRolesList
                    activeUserAccessRole={activeUserAccessRole}
                    userAccessRoles={userAccessRoles}
                    setActiveUserAccessRole={setActiveUserAccessRole}
                  /> */}
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           User Name: 
                           <span style={{ color: "red", margin: "0 4px" }}>*</span>
                          </Form.Label>
                        <Form.Control
                          type="text"
                          id="username"
                          placeholder="User Name"
                          autoComplete="off"
                          maxLength={50}
                          value={username}
                          readOnly
                          onFocus={(e) => e.target.removeAttribute("readOnly")}
                          onChange={handleUsernameChange}
                          onBlur={(e) => validateUsername(e.target.value)}
                          className={usernameError ? "is-invalid" : ""}
                          required
                        />
                        {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                        {usernameTakenMessage && <small className="text-danger">{usernameTakenMessage}</small>}

                      </Form.Group>
                      <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           Full Name: 
                           <span style={{ color: "red", margin: "0 4px" }}>*</span>
                          </Form.Label>
                        <Form.Control
                          type="text"
                          id="name"
                          placeholder="Name"
                          maxLength={100}
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            validateName(e.target.value);
                          }}
                          onBlur={(e) => validateName(e.target.value)}
                          className={nameError ? "is-invalid" : ""}
                          required
                        />
                        {nameError && <div className="invalid-feedback">{nameError}</div>}
                      </Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           Email: 
                           <span style={{ color: "red", margin: "0 4px" }}>*</span>
                          </Form.Label>
                        <Form.Control
                          type="email"
                          id="email"
                          placeholder="Email"
                          maxLength={100}
                          value={email}
                          onChange={handleEmailChange}
                          className={emailFieldError ? "is-invalid" : ""}
                          required
                        />
                        {emailFieldError && (
                          <div className="invalid-feedback">{emailFieldError}</div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           ACL Settings:
                           <span style={{ color: "red", margin: "0 4px" }}>*</span>
                          </Form.Label>
                        <Form.Select
                          id="aclSetting"
                          required
                          value={selectedACL}
                          className={`p-2 ${aclError ? "is-invalid" : ""}`}
                          onChange={(e) => setSelectedACL(e.target.value)}
                        >
                          <option value={""}>ACL Setting</option>
                          {aclSettingList.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.id}>
                                {val.acl_name}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {aclError && <div className="invalid-feedback">{aclError}</div>}
                      </Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           Password: 
                           <span style={{ color: "red", margin: "0 4px" }}>*</span>
                          </Form.Label>
                        <Form.Control
                          type="password"
                          id="pass"
                          placeholder="Password"
                          autoComplete="off"
                          maxLength={100}
                          value={password}
                          readOnly
                          onFocus={(e) => e.target.removeAttribute("readOnly")}
                          onChange={(e) => setPassword(e.target.value)}
                          className={passwordError ? "is-invalid" : ""}
                          required
                        />
                        {passwordError && (
                          <div className="invalid-feedback">{passwordError}</div>
                        )}
                      </Form.Group>
                      <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           Confirm Password:
                           <span style={{ color: "red", margin: "0 4px" }}>*</span>
                          </Form.Label>
                        <Form.Control
                          type="password"
                          id="rpass"
                          placeholder="Confirm Password"
                          autoComplete="off"
                          maxLength={100}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className={confirmPasswordError ? "is-invalid" : ""}
                          required
                        />
                        {confirmPasswordError && (
                          <div className="invalid-feedback">{confirmPasswordError}</div>
                        )}
                      </Form.Group>
                    </div>



                    {/* Row with userType and licence dropdowns */}
                    {(isSuperAdmin || isCompanyAdmin || isCallCenterAdmin || isReseller) ? (
                      <div className="row">
                        {/* userType Dropdown */}
                        <Form.Group className="col-md-6 form-group">
                          <Form.Label>
                           User Type 
                           <span style={{ color: "red", margin: "0 4px"  }}>*</span>
                          </Form.Label>
                          <Form.Select
                            id="userType"
                            required
                            value={selectedUserType}
                            className={`p-2 ${userTypeError ? "is-invalid" : ""}`}
                            onChange={(e) => setSelectedUserType(e.target.value)}
                          >
                            <option value="" disabled hidden>
                              UserType
                            </option>
                            {/* {(isOwnCompany || isCompanyAdmin || isCallCenterAdmin) && (
                              <>
                                <option key="2" value="role_ccadmin">
                                  Call-Center
                                </option>
                                <option key="3" value="role_ccteamlead">
                                  Call Centre Team Lead
                                </option>
                              </>
                            )} */}
                            {(isOwnCompany && isCompanyAdmin) && (
                              <>
                                <option key="2" value="role_ccadmin">
                                  Call-Center
                                </option>
                              </>
                            )}
                            {isSuperAdmin && (
                              <>
                                <option key="1" value="role_sub_superadmin">
                                  Sub-Superadmin
                                </option>
                                {!isOwnCompany &&
                                <option key="2" value="role_reseller">
                                  Reseller
                                </option>}
                              </>
                            )}
                            {isCompanyAdmin && !isOwnCompany && (
                              <>
                                <option key="1" value="role_cadmin">
                                  Company User
                                </option>
                                {/* <option key="2" value="role_ccadmin">
                                  Call-Center
                                </option> */}
                              </>
                            )}
                            {isCallCenterAdmin && (
                              <>
                                <option key="1" value="role_ccadmin">
                                  Call Centre Admin User
                                </option>
                                
                                <option key="2" value="role_ccagent">
                                  Call Centre Admin Agent
                                </option> 
                               
                                <option key="3" value="role_ccteamlead">
                                  Call Centre Admin Team Lead
                                </option>
                              </>
                            )}
                            {isReseller && !isOwnCompany && (
                              <>
                                {(loggedUserParent === USER_ROLES.RESELLER && loggedUserSuperParent === USER_ROLES.RESELLER &&
                                  loggedUserSuperSuperParent === USER_ROLES.RESELLER) ? (
                                  <option key="2" value="role_cadmin">
                                    Company User
                                  </option>
                                ) : (
                                  <>
                                    <option key="1" value="role_reseller">
                                      Reseller
                                    </option>
                                    <option key="2" value="role_cadmin">
                                      Company User
                                    </option>
                                  </>
                                )}
                              </>

                            )}
                          </Form.Select>
                          {userTypeError && <div className="invalid-feedback">{userTypeError}</div>}


                        </Form.Group>
                        {selectedUserType === "role_ccadmin" && (
                          <Form.Group className="col-md-6 form-group">
                              <Form.Label>
                              Select Flow Type <span style={{ color: "red", margin: "0 4px" }}>*</span>
                             </Form.Label>
                            <Form.Select
                              id="callCenterType"
                              required
                              value={selectedFlowType || ""}
                              className="p-2"
                              onChange={(e) => setSelectedFlowType(e.target.value)}
                            >
                              <option value="" disabled hidden>
                                Select Flow Type
                              </option>
                              <option value="0">Asterisk</option>
                              {/* <option value="1">Jambonz</option> */}
                            </Form.Select>
                          </Form.Group>
                        )}

                      </div>
                    ) : (
                      /* Row with only licence dropdown when userType is not rendered */
                      <>
                        {/* {isSuperAdmin && <div className="row">
                          <Form.Group className="col-md-6 form-group">
                            <Form.Select
                              id="licence"
                              required
                              value={licence}
                              className="p-2"
                              onChange={(e) => setSelectedLicence(e.target.value)}
                            >
                              <option value="" disabled hidden>
                                Select Licence
                              </option>
                              {Array.from({ length: 10 }, (_, i) => (
                                <option key={(i + 1) * 10} value={(i + 1) * 10}>
                                  {(i + 1) * 10}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </div>
                        } */}
                      </>
                    )}
                    {(selectedUserType === USER_ROLES.RESELLER || selectedUserType === USER_ROLES.COMPANY_ADMIN) ? (
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Select Company <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Select
                          id="aclSetting"
                          required
                          value={selectedCompany}
                          className={`p-2 ${aclError ? "is-invalid" : ""}`}
                          onChange={(e) => setSelectedCompany(e.target.value)}
                        >
                          <option value={""}>Company</option>
                          {companyList.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.id}>
                                {val.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {aclError && <div className="invalid-feedback">{aclError}</div>}
                      </Form.Group>
                    ) : (
                      <></>
                    )}

                    {(selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) ? (
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Select Call Center <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Select
                          id="aclSetting"
                          required
                          value={selectedCallCenter}
                          className="p-2"
                          onChange={(e) => setSelectedCallCenter(e.target.value)}
                        >
                          <option value={""}>Call Center</option>
                          {callCenterList.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.id}>
                                {val.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    ) : (
                      <></>
                    )}
                    <>
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Select Expiry Date <span style={{ color: "red",margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Control
                          type="date"
                          min={new Date().toISOString().split("T")[0]}
                          max={(() => {
                            const maxDate = new Date();
                            maxDate.setFullYear(maxDate.getFullYear() + 100);
                            return maxDate.toISOString().split("T")[0];
                          })()}
                          value={expiryDate}
                          onChange={(e) => setExpiryDate(e.target.value)}
                          className={expiryDateError ? "is-invalid" : ""}
                        />
                        {expiryDateError && (
                          <div className="invalid-feedback">{expiryDateError}</div>
                        )}

                      </Form.Group>
                    </>

                    {showTtsPlanId &&
                    <>
                      <Form.Group className="col-md-6 mb-5">
                        <Form.Label>Select TTS Plan <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Select
                          id="tts_plan_id"
                          required
                          value={tts_plan_id}
                          className="p-2"
                          onChange={(e) => setTtsPlanId(e.target.value)}
                        >
                          <option value={""}>Select TTS Plan</option>
                          {ttsPlanList.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.id}>
                                {val.plan_name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </>}
                    <Button
                      onClick={async () => {
                        submitForm();
                      }}
                      type="button"
                      variant="btn btn-primary"
                      className="mt-4"
                      disabled={buttonDisable}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          &nbsp; Adding...
                        </>
                      ) : (
                        "Add New User"
                      )}
                    </Button>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default UserAdd;
